<template lang="pug">
	.real-estate-map(v-if="position && position.lat != null && position.lng != null")
		GmapMap(:center="position", :zoom="zoom", map-type-id="roadmap", :options="options", ref="gmap", style="width: 100%; height: 100%")
			GmapCircle(:center="position" :radius="100", :options="markerOptions")
		p {{$t('AADAT.mapText')}}
</template>
<script>
import { mapState } from 'vuex';

export default {
	data: () => ({
		zoom: 15,
		options: {
			zoomControl: true,
			mapTypeControl: false,
			scaleControl: false,
			streetViewControl: false,
			rotateControl: false,
			fullscreenControl: true,
			disableDefaultUI: false,
			minZoom: 8,
			maxZoom: 15
		},
		markerOptions: {
			strokeColor: '#52ae30',
			strokeWeight: 0,
			fillColor: '#52ae30',
			fillOpacity: 0.35
		}
	}),
	computed: {
		...mapState('real-estate-data', ['position'])
	}
};
</script>
<style lang="css" scoped>
@import '../../common/variables.pcss';

	.real-estate-map {
		height: 280px;
		margin-bottom: 60px;
	}
</style>